import React from "react";
import { AddressContext, getNewAddress } from "./AddressContext";
import { useEffect, useContext } from "react";
import { useGetList, GetListParams } from "react-admin";

import { useRecordContext } from "react-admin";

import {
  Box,
  Pagination,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { AddressCard } from "./AddressCard";
import { Address } from "./Address";

const AddressList = (props) => {
  const { ...rest } = props;
  const { addresses, setAddresses, page, perPage, setSelected, setTotal } = useContext(AddressContext);

  const record = useRecordContext();

  const { data, total } = useGetList("admin/addresses", {
    pagination: { page: page, perPage: perPage },
    sort: { field: "default_billing,default_shipping,id", order: "DESC" },
    filter: { "user.id": record.id },
  });

  useEffect(() => {
    if (data) {
      setTotal(total);
      if (data.length > 0) {
        setAddresses(data as Address[]);
        setSelected(data[0]);
      } else {
        setSelected(getNewAddress());
        setAddresses([]);
      }
    }
  }, [data]);

  if (addresses) {
    return (
      <Box {...rest} display="flex" flexDirection="column">
        <Button
          startIcon={<AddIcon />}
          onClick={() => setSelected(getNewAddress())}
        >
          Add new address
        </Button>
        {addresses.map((address, index) => {
          return <AddressCard address={address} key={index} />;
        })}

        <CustomPagination />
      </Box>
    );
  }
};

export const CustomPagination = (props) => {
  const { ...rest } = props;
  const { page, setPage, perPage, setPerPage, total } =
    useContext(AddressContext);

  const menuItemValues: number[] = [2, 3, 5, 10, 15];
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{ justifyContent: "space-between", gap: "10px"}}
      {...rest}
    >
      <FormControl sx={{ minWidth: "10%", maxWidth: "30%" }} variant="outlined">
        <InputLabel id="per-page">Per page</InputLabel>
        <Select
          labelId="per-page"
          value={perPage}
          onChange={(e) => setPerPage(+e.target.value)}
          label="Per page"
        >
          {menuItemValues.map((value, index) => {
            return (
              <MenuItem value={value} key={index}>
                {value}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      {total ? (
        <Pagination
          count={Math.ceil(total / perPage)}
          page={page}
          onChange={handleChange}
          boundaryCount={0}
          siblingCount={0}
        />
      ) : (
        <></>
      )}
    </Box>
  );
};

export default AddressList;
